import type { ZoneGeoJsonPoint, ZoneGeoJsonPolygon } from '@chukua/common';

/**
 * Planar (shoelace) centroid of a polygon's outer ring — a client-side preview
 * only, good enough for an admin drawing a zone by eye. The stored value is
 * whatever the admin confirms, never recomputed server-side.
 */
export function polygonCentroid(polygon: ZoneGeoJsonPolygon): ZoneGeoJsonPoint {
  const [ring] = polygon.coordinates;
  let signedArea = 0;
  let cx = 0;
  let cy = 0;

  for (let i = 0; i < ring.length - 1; i++) {
    const [x0, y0] = ring[i];
    const [x1, y1] = ring[i + 1];
    const cross = x0 * y1 - x1 * y0;
    signedArea += cross;
    cx += (x0 + x1) * cross;
    cy += (y0 + y1) * cross;
  }
  signedArea /= 2;

  if (signedArea === 0) {
    const points = ring.slice(0, -1);
    const [sumX, sumY] = points.reduce(([ax, ay], [x, y]) => [ax + x, ay + y], [0, 0]);
    return { type: 'Point', coordinates: [sumX / points.length, sumY / points.length] };
  }

  return { type: 'Point', coordinates: [cx / (6 * signedArea), cy / (6 * signedArea)] };
}
